module.exports = __webpack_public_path__ + "static/media/award3@2x.01961696.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_230/imgs/award3@2x.png
// module id = 1759
// module chunks = 0